
import React, { Component } from 'react';
import Moment from 'react-moment';
import 'moment-timezone';
import 'moment/locale/es';
import { Col, Row } from 'react-bootstrap';
import '../../css/interactions/interaction.css';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import { compose } from 'redux';
import { selectInteraction } from '../../redux/interactionsSlice';
import ChatsService from '../../controllers/ChatController';
import { useNavigate } from "react-router-dom";

class InteractionChat extends Component {

    click = (e) => {
        e.preventDefault();
        this.props.selectInteraction(this.props.id);
        let user = JSON.parse(localStorage.getItem("fc-logged"))
        ChatsService.sendSeen(this.props.id, user.userId);
        this.props.navigate(window.location.href.indexOf("onhold") > -1 ? "onhold" : "chat");
    }

    render() {

        let className = "icon " + this.props.channel;
        return (
            <div className={'interaction-item ' + (this.props.selected ? "badge-light-primary" : "")} onClick={this.click}
                style={{ backgroundColor: (this.props.color + (this.props.selected ? "99" : "") || "") }} >
                <Row>
                    <Col xxl={2} lg={1}><div className={className}
                        style={this.props.image != null && this.props.image.trim() !== "" ? { backgroundImage: `url("${this.props.image}")` } : {}}></div></Col>

                    <Col xxl={8} lg={8}>
                        <div className={this.props.color ? 'text-white' : 'text-muted'}>{this.props.group}</div>
                        <div className={(this.props.color ? 'text-white' : 'text-primary') + ' intecation-name'}>{this.props.name}</div>
                        <div className={(this.props.color ? 'text-white' : 'text-muted') + ' last-message'}>{this.props.lastMessage}</div>
                    </Col>

                    <Col xxl={2} lg={2}>
                        <Row><Col><div className={'float-end ' + (this.props.color ? 'text-white' : 'time')}><Moment format='HH:mm'>{this.props.date}</Moment></div></Col></Row>
                        <Row><Col>{this.props.unreadMessages != null && this.props.unreadMessages > 0 ? <div className='float-end unread'>{this.props.unreadMessages}</div> : null}</Col></Row>
                    </Col>
                </Row>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
    };
};

function WithNavigate(props) {
    let navigate = useNavigate();
    return <InteractionChat {...props} navigate={navigate} />
}


export default compose(connect(mapStateToProps, { selectInteraction }), withTranslation())(WithNavigate);
